// extracted by mini-css-extract-plugin
module.exports = {"title":"title__3rvr6","form":"form__1-fdq","textarea":"textarea__3gHsi","modal":"modal__21IOj"};